import {
  gqlQuery,
  gqlMutate,
  mutationMockHandler,
} from '@hapana/shared/web/services/requests.service'
import {
  setCorporateUserCorporateCustomIntegrationMutation,
  updateCorporateClassPassMutation,
} from '_services/graphql/corporate-integrations.mutations'
import {
  availableCorporateUserCorporateThirdPartyIntegrationsQuery,
  corporateBySubdomainQuery,
  corporateQuery,
} from '_services/graphql/corporate-integrations.queries'
import {
  AVAILABLE_CORPORATE_USER_INTEGRATIONS_MOCK_RESPONSE,
  CORPORATE_CUSTOM_INTEGRATIONS_MOCK_RESPONSE,
  SET_CORPORATE_USER_CUSTOM_INTEGRATION_MOCK_RESPONSE,
  CORPORATE_BY_URL_PREFIX_MOCK_RESPONSE,
} from '_mocks/integrations.mock'

export const AVAILABLE_CORPORATE_USER_INTEGRATIONS_QUERY_KEY =
  'AVAILABLE_CORPORATE_USER_INTEGRATIONS_QUERY'
export const CORPORATE_QUERY_KEY = 'CORPORATE_QUERY'
export const CORPORATE_BY_PREFIX_KEY = 'CORPORATE_BY_PREFIX'

export const getCorporateBySubdomainQuery = gqlQuery({
  key: CORPORATE_BY_PREFIX_KEY,
  query: corporateBySubdomainQuery,
  mockResponse: CORPORATE_BY_URL_PREFIX_MOCK_RESPONSE,
  options: {
    isV1: false,
  },
})

export const listAvailableCorporateUserIntegrations = gqlQuery({
  key: AVAILABLE_CORPORATE_USER_INTEGRATIONS_QUERY_KEY,
  query: availableCorporateUserCorporateThirdPartyIntegrationsQuery,
  mockResponse: AVAILABLE_CORPORATE_USER_INTEGRATIONS_MOCK_RESPONSE,
  options: {
    isV1: false,
  },
})

export const listCorporateCustomIntegrations = gqlQuery({
  key: CORPORATE_QUERY_KEY,
  query: corporateQuery,
  mockResponse: CORPORATE_CUSTOM_INTEGRATIONS_MOCK_RESPONSE,
  options: {
    isV1: false,
  },
})
export const setCorporateUserCustomIntegration = ({ keys, integrationId }) =>
  gqlMutate({
    mutation: setCorporateUserCorporateCustomIntegrationMutation,
    variables: {
      keys,
      integrationId,
    },
    options: {
      isV1: false,
    },
  })

setCorporateUserCustomIntegration.mockHandler = mutationMockHandler(
  setCorporateUserCorporateCustomIntegrationMutation,
  {
    setCorporateUserCorporateCustomIntegration:
      SET_CORPORATE_USER_CUSTOM_INTEGRATION_MOCK_RESPONSE.data,
  }
)

export const updateCorporateClassPass = ({ corporateId, siteIds }) =>
  gqlMutate({
    mutation: updateCorporateClassPassMutation,
    variables: {
      corporateId,
      siteIds,
    },
    options: {
      isV1: false,
    },
  })

updateCorporateClassPass.mockHandler = mutationMockHandler(updateCorporateClassPassMutation, {
  updateCorporateClassPass: {
    corporateId: 'mock-corporate-id',
    integrations: {
      classPass: {
        siteIds: [],
      },
    },
  },
})
